const RegisterKey = "hb_register";

export function recordRegister() {
  localStorage.setItem(RegisterKey, Date.now().toString());
}

export function isRegisterOver24H() {
  const time = localStorage.getItem(RegisterKey);

  // 有记录才判断
  if (time) {
    return Date.now() - Number(time) > 24 * 60 * 60 * 1000;
  }

  // 没有记录就算超过24小时
  return true;
}
